
import { getDisplayCouponInfo } from '@/api/displayCoupon/display-coupon';
import { HeaderTabType } from '@/config/page-tab';
import { CustomException } from '@tencent/ppd-base-libs';
import { to } from '@tencent/wphk-base-utils';
import {
  clickRegister, getBannerConfig, getStampInfo, getCouponInfo,
} from '../api/index';

const VisitTypeConfig = {
  [HeaderTabType.couponlist]: '1', // 优惠券
  [HeaderTabType.stamplist]: '2', // 印花
  [HeaderTabType.displaycouponlist]: '3', // 商户展示券
};

type VisitType = keyof typeof HeaderTabType;

export const updateRedDot = (type: VisitType) => {
  if (type) {
    clickRegister({ visit_type: VisitTypeConfig[type] });
  }
};

// 1 代表有红点
const hasRedPoint = '1';
/**
 * 获取优惠券奖品信息(是否有红点、数量)
 * @returns boolean
 */
const getCouponPrizeInfo = async () => {
  const bannerConfig = getBannerConfig();
  const couponInfo = await getCouponInfo({
    expire_days: bannerConfig.coupon_expire_days,
  });
  return {
    hasRedDot: couponInfo.red_point === hasRedPoint,
    count: +couponInfo.total_cnt,
  };
};

/**
 * 获取印花奖品信息(是否有红点、数量)
 * @returns boolean
 */
const getStampPrizeInfo = async () => {
  const bannerConfig = getBannerConfig();
  const stampInfo = await getStampInfo({
    expire_days: bannerConfig.stamp_expire_days,
  });
  return {
    hasRedDot: stampInfo.red_point === hasRedPoint,
    count: +stampInfo.total_cnt,
  };
};

/**
 * 获取商户展示券奖品信息(是否有红点、数量)
 * @returns boolean
 */
const getDisplayCouponPrizeInfo = async () => {
  const res = await getDisplayCouponInfo();
  return {
    hasRedDot: res.red_point === hasRedPoint,
    count: +res.total_cnt,
  };
};

/**
 * 获取用户奖品tab信息
 */
export async function getUserPrizeTabInfo() {
  const [err, res] = await to(Promise.all([
    getCouponPrizeInfo(),
    getStampPrizeInfo(),
    getDisplayCouponPrizeInfo(),
  ]));
  if (err) {
    throw new CustomException(err, 'getRedDotFail', '优惠专区获取红点失败');
  }
  return {
    [HeaderTabType.couponlist]: res[0],
    [HeaderTabType.stamplist]: res[1],
    [HeaderTabType.displaycouponlist]: res[2],
  };
}
